<template>
  <div>
    <div class="page-container">
      <div class="father">
        <div class="text_center">
          <h1 class="title wow fadeInUp ProductTitle">人才培养目标</h1>
        </div>
        <!-- 轮播图 -->
        <div
          class="image-slider"
          @touchstart="touchStart"
          @touchmove="touchMove"
          @touchend="touchEnd"
        >
          <div
            class="image-wrapper"
            :style="{ transform: `translateX(${translateX + 550}px)` }"
          >
            <img
              v-for="(image, index) in imageList"
              :key="index"
              :src="image.src"
              :alt="image.alt"
              :class="{
                'highlight-image': currentIndex === index,
                'bright-image': currentIndex === index,
                'dark-image': currentIndex !== index,
              }"
              class="image-item wow fadeInUp"
            />
          </div>
        </div>
        <div class="animate__animated animate__fadeInUp">
          <!-- 下方切换按钮 -->
          <div class="switch-buttons animate__animated animate__fadeInUp">
            <span
              v-for="(btnText, btnIndex) in switchTexts"
              :key="btnIndex"
              @click="switchImage(btnIndex)"
              :class="{ active: currentIndex === btnIndex }"
            >
              {{ btnText }}
            </span>
          </div>
          <div class="description-section">
            <p
              v-if="currentIndex === 0"
              class="animate__animated animate__fadeInUp"
            >
              课程将通过大量实际操作项目，让学生深度参与，从设备操控到团队协作，全方位积累实践经验。
            </p>
            <p
              v-if="currentIndex === 1"
              class="animate__animated animate__fadeInUp"
            >
              以明确的就业和成果产出为目标，课程注重学生对最终作品质量和实际效益的把控能力培养。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // 页面加载完成后，手动触发一次图片切换逻辑，让图片移动到对应位置
    this.switchImage(this.currentIndex);
  },
  data() {
    return {
      imageList: [
        {
          src: "https://download.hecoos.com/enlightv/2025-35/474af4677eb1f5d047ca13ab37898271.png",
        },
        {
          src: "https://download.hecoos.com/enlightv/2025-35/85bbdd1fe22bffbd30be7581cd2fc2c9.png",
          alt: "图片2",
        },
      ],
      switchTexts: ["以实践为手段", "以结果为导向"],
      currentIndex: 0,
      translateX: 0,
      startX: 0,
      isMoving: false,
    };
  },
  methods: {
    touchStart(event) {
      this.startX = event.touches[0].clientX;
      this.isMoving = true;
    },
    touchMove(event) {
      if (this.isMoving) {
        const moveX = event.touches[0].clientX - this.startX;
        this.translateX += moveX;
        this.startX = event.touches[0].clientX;
      }
    },
    touchEnd() {
      this.isMoving = false;
      const targetIndex = Math.round(-this.translateX / 770); // 假设图片宽度为300px
      this.currentIndex = Math.min(
        Math.max(targetIndex, 0),
        this.imageList.length - 1
      );
      // 根据当前索引计算位移
      this.translateX = -this.currentIndex * 770;
    },
    switchImage(index) {
      this.currentIndex = index;
      // 根据点击的索引计算位移
      this.translateX = -index * 770;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/optimize_adaptation.scss";
</style>
<style scoped>
.page-container {
  text-align: center;
  color: white;
  background-color: #121416;
  overflow: hidden;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 950px;
}

.title {
  /* padding: 50px 0; */
  font-size: 72px;
  text-align: center;
}

.image-slider {
  position: relative;
  /* margin-bottom: 30px; */
  transition: all 1s cubic-bezier(0.25, 0.1, 0.25, 1);
  width: 100%;
  margin-bottom: 20px;
}
.text_center {
  width: 65%;
  margin: 0 auto 60px;
}
.image-wrapper {
  display: flex;
  width: 1800px; /* 假设两张图片，每张1000px */
  transition: all 1s cubic-bezier(0.25, 0.1, 0.25, 1);
  margin: 0 auto;
}
.image-item {
  position: relative;
  /* bottom: 20px; */
  /* width: 500px;
  height: 560px; */
  margin-right: 55px; /* 去掉图片间的间距 */
}
.image-wrapper img {
  /* width: 839px; */
  transition: transform 1s ease, opacity 1s ease;
}
.switch-buttons {
  margin-bottom: 20px;
  /* border: 1px solid red; */
  padding: 30px 0 0 0;
}
.switch-buttons span {
  cursor: pointer;
  padding: 5px 10px;
  margin: 0 10px;
  font-size: 36px;
  color: #7e7e83;
}

.switch-buttons span.active {
  color: white;
  border-bottom: 2px solid white;
}

.description-section {
  padding: 0 100px;
}
.description-section p {
  color: gray;
  font-size: 16px;
}
.bright-image {
  filter: brightness(1); /* 选中图片亮度正常 */
}

.dark-image {
  filter: brightness(0.5); /* 未选中图片亮度降低 */
  transition: filter 0.3s ease; /* 添加过渡效果，让亮度变化更平滑 */
}
/* .center_con{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
} */
.father {
  /* position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%); */
  height: 800px;
}
</style>
